var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoEwpRound = function SvgLogoEwpRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.638 23.725 36.1 44.1l3.538-3.1-6.3-17.275h-4.7ZM37.087 23.725 44.55 44.1l3.538-3.1-6.3-17.275h-4.7ZM50.563 23.725h-5.038l3.45 9.325c1.737-1.375 4.625-4.137 4.387-6.137-.25-2.15-2.362-3.026-2.8-3.188ZM25.95 28.1l-1.587-4.375H10.625l1.7 4.375H25.95ZM28.925 36.25l-1.6-4.375h-14.5l1.7 4.375h14.4ZM15.013 39.987l1.7 4.375h15.162l-1.587-4.375H15.013Z",
    fill: "#fff"
  })));
};

export default SvgLogoEwpRound;